import React, { useEffect, useRef, useState } from "react";
import data from "../../json/landingpage/highlights.json";
import { ReactComponent as Icon } from "../../Icons/whitearrow.svg";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

const Highlightsnew = () => {
  const [currentItem, setCurrentItem] = useState(0);
  const parentRef = useRef(null);
  const imgRef = useRef(null);

  const handleNext = (item) => {
    if (item < data.news.length - 1) {
      setCurrentItem((prev) => prev + 1);
    }
  };
  const handlePrev = (item) => {
    if (item > 0) {
      setCurrentItem((prev) => prev - 1);
    }
  };

  const [dynamicPadding, setDynamicPadding] = useState(0);

  useEffect(() => {
    const updatePadding = () => {
      const width = window.innerWidth;
      if (width >= 768 && width < 1024 && imgRef.current) {
        // md–lg range
        setDynamicPadding(imgRef.current.offsetHeight);
      } else {
        setDynamicPadding(0); // disable outside md–lg
      }
    };

    updatePadding();
    window.addEventListener("resize", updatePadding);
    return () => window.removeEventListener("resize", updatePadding);
  }, []);

  return (
    <div className="w-screen heighlightNew">
      <div className="2xl:container  w-full m-auto py-20 lg:py-[100px] ">
        <div className="flex flex-col gap-4 w-full text-center items-center">
          <h1 className="text-orangeyellow text font-semibold text-16 md:text-18 lg:text-20 text-center">
            {data.Title}
          </h1>
          <h2 className="text-24 md:text-28 lg:text-48 font-bold text-primarycolor text-center w-[90%] md:w-[80%] lg:w-[80%]  text-24 md:text-36">
            {parse(data.Highlightheading)}
          </h2>
          <p className="text-16 md:text-18  text-center sm:w-[60%] w-[80%]  text-regular text-secondaryblack">
            {data.subheading}
          </p>
        </div>

        <div className="flex flex-col items-end landing-highlight">
          <div ref={imgRef} className="high-img1 lg:w-[45%] md:w-[80%] w-[90%]">
            <img
              className="md:h-[60vh] md:max-h-[450px] w-full"
              src={process.env.PUBLIC_URL + data.news[currentItem].img}
              alt="img"
            />
          </div>
          <div
            ref={parentRef}
            style={{
              paddingTop: dynamicPadding ? `${dynamicPadding-50}px` : undefined,
            }}
            className="flex flex-col bg-Darkgray w-[90%] lg:w-[70%] px-6 lg:px-0 py-10 lg:pr-20 gap-8 min-h-[500px] justify-between pt-[50%] md:pt-[40%] lg:pt-6 "
          >
            <div className="lg:w-[70%] w-full  self-end flex flex-col gap-6 pt-5">
              <h3 className="text-20 md:text-28 lg:text-32 text-white font-semibold">
                {data.news[currentItem].shortnews}
              </h3>
              <p className="text-16 md:text-18 lg:text-24 font-medium text-orangeyellow">
                {data.news[currentItem].date}
              </p>
              <p className="font-regular text-14 md:text-16 lg:text-18 text-white">
                {data.news[currentItem].brief1}
              </p>
              {data.news[currentItem].brief2 ? (
                <p className="font-regular text-14 md:text-16 lg:text-18 text-white">
                  {data.news[currentItem].brief2}
                </p>
              ) : (
                <></>
              )}
            </div>
            {data.news[currentItem].brief3 ? (
              <p className="font-regular lg:pl-10 text-14 md:text-16 lg:text-18 text-white">
                {data.news[currentItem].brief3}
              </p>
            ) : (
              <></>
            )}

            <div className="flex justify-between items-center lg:pl-10">
              <div className="flex gap-5 text-white">
                <button
                  onClick={() => handlePrev(currentItem)}
                  className=" flex max-[450px]:h-[35px] max-[450px]:w-[35px] w-[45px] h-[45px] rounded-full border-[1px] border-highlight hover:bg-ctaorange publish-hover flex justify-center items-center"
                >
                  <Icon className="text-highlight arrowicon rotate-180" />
                </button>
                <button
                  onClick={() => handleNext(currentItem)}
                  className="flex max-[450px]:h-[35px] max-[450px]:w-[35px] w-[45px] h-[45px] rounded-full border-[1px] border-highlight hover:bg-ctaorange publish-hover flex justify-center items-center"
                >
                  <Icon className="text-highlight arrowicon" />
                </button>
              </div>
              <div className="flex  justify-center md:justify-start">
                <Link
                  to={"/company/news"}
                  className="py-[12px] lg:py-[16px] px-4 sm:px-5 lg:px-10 bg-orangebg rounded-[16px] hover:bg-btnhover"
                >
                  <p className="sm:text-base text-12 font-semibold text-white">
                    See all updates
                  </p>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Highlightsnew;
